import { render } from "./SelectedCarousel.vue?vue&type=template&id=77e0010a&scoped=true"
import script from "./SelectedCarousel.vue?vue&type=script&lang=js"
export * from "./SelectedCarousel.vue?vue&type=script&lang=js"

import "./SelectedCarousel.vue?vue&type=style&index=0&id=77e0010a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-77e0010a"]])

export default __exports__